import { Type } from 'class-transformer';
import { Material } from 'types/models/inventory';
import { PropertyDetails } from 'types/models/inventory/PropertyDetails';
import { SampleOrderV2 } from 'types/models/samples/SampleOrderV2';
import { SamplePoolEntry } from 'types/models/samples/SamplePoolEntry';
import { ServiceLineMaterial } from 'types/models/ServiceLineMaterial';
import { Nullable } from '@cast/leadcast-types';
import { OnPremisePlumbing } from '../PremisePlumbing';

type BaseProperty = Omit<
  PropertyDetails,
  | 'onPremisePlumbing'
  | 'serviceLines'
  | 'inspections'
  | 'rightOfEntry'
  | 'geometry'
  | 'parcelId'
  | 'pwsId'
  | 'properties'
  | 'startDate'
  | 'endDate'
  | 'lifecycleStatusCode'
  | 'registrationCode'
>;
export interface SamplingPropertyV2 extends BaseProperty {
  sampleOrders: SampleOrderV2[];
  samplingPools: SamplePoolEntry[];
  currentSamplingPool: Nullable<SamplePoolEntry>;
  materials: ServiceLineMaterial[];
  onPremisePlumbingMaterial: Nullable<Material>;
  onPremisePlumbing: Pick<OnPremisePlumbing, 'isLeadSolder'>;
  eligibleSamplingProgramIds?: string[];
}

export class SamplingPropertyV2 {
  @Type(() => SampleOrderV2)
  sampleOrders: SampleOrderV2[] = [];

  @Type(() => SamplePoolEntry)
  samplingPools: SamplePoolEntry[] = [];

  @Type(() => SamplePoolEntry)
  currentSamplingPool: Nullable<SamplePoolEntry> = null;

  @Type(() => ServiceLineMaterial)
  materials: ServiceLineMaterial[] = [];

  @Type(() => Material)
  onPremisePlumbingMaterial: Nullable<Material> = null;

  get privateMaterials(): ServiceLineMaterial[] {
    return this.materials.filter((slm) => slm.serviceSide === 'Private' && slm.isActive);
  }

  get utilityMaterials(): ServiceLineMaterial[] {
    return this.materials.filter((slm) => slm.serviceSide === 'Utility' && slm.isActive);
  }

  get mostRecentlyReplacedMaterial(): ServiceLineMaterial | null {
    return this.materials.reduce<ServiceLineMaterial | null>((mostRecent, material) => {
      const beginOnDate = material.beginOn ? new Date(material.beginOn) : null;

      if (
        material.method?.code === 'RR' &&
        (!mostRecent ||
          (beginOnDate && (!mostRecent.beginOn || beginOnDate > new Date(mostRecent.beginOn))))
      ) {
        return material;
      }
      return mostRecent;
    }, null);
  }
}
